import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';

import Anchor from '../Anchor';

import logo from '../../assets/images/logo.png';

const LogoAnchor = styled(Anchor)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogoImg = styled.img`
  height: ${remCalc(44)};
`;

const Logo = ({ baseUrl, link, alt, padded }) => (
  <LogoAnchor href={`${baseUrl}${link}`} padded={padded}>
    <LogoImg src={logo} alt={alt} />
  </LogoAnchor>
);

export default Logo;
